enum AlertTiming {
  WorkHours = "Work hours",
  OffHours = "Off-hours",
  Weekend = "Weekend",
  NightTime = "Night-time",
}

export default AlertTiming;
